import API from "Services/Api";
import { sanitizeInput } from "Utils/Sanitize";
import { Product } from "Hooks/useProducts/interface";

type UpdateProductRuleProps = {
  productId: number;
  payload: ProductRule;
};

export interface ProductRule {
  product_id: number | null;
  synonyms: string;
  rules: {
    client_id: number;
    slug?: string;
    substitutions: number[];
  }[];
}

export type RulesList = {
  client_id: number;
  client_name: string;
  substitutions: {
    product_id: number;
    product_name: string;
    product_sku: string;
  }[];
};

export type ProductRuleList = Omit<ProductRule, "rules"> & {
  id: number;
  product_name: string;
  rules: RulesList[];
};

export type ListProductsRules = {
  current_page: number;
  data: ProductRuleList[];
  last_page: number;
  per_page: number;
  total: number;
};

export interface ProductRulesFormValues {
  product: { id: number; product: string };
  synonyms: string;
  rules: {
    client_id: number;
    substitutions: Product[];
  }[];
}

export const fetchProductRules = async (products_ids: string) => {
  try {
    const response = await API.get(
      `/products/product_rules/${products_ids}`,
      {}
    );

    return response.data;
  } catch (err) {
    console.error(err);
    throw "Ops! Ocorreu um erro ao buscar as regras do produto";
  }
};

export const listClients = async () => {
  try {
    const response = await API.get("/product/synonyms/clients");
    return response.data;
  } catch (error: any) {
    throw error.response.data.errors;
  }
};

export const createProductRule = async (payload: ProductRule) => {
  try {
    const response = await API.post("/product/synonyms", { ...payload });
    return response.data;
  } catch (error: any) {
    throw error.response.data.errors;
  }
};

export const listProductsRules = async (
  term: string,
  page: number
): Promise<ListProductsRules> => {
  const searchedTerm = sanitizeInput(term);
  const response = await API.get(
    `/product/synonyms?search=${searchedTerm}&page=${page}&per_page=20`
  );
  return response.data;
};

export const showProductRule = async (productId: number) => {
  const response = await API.get(`/product/synonyms/${productId}`);
  return response.data.data;
};

export const updateProductRule = async ({
  productId,
  payload,
}: UpdateProductRuleProps) => {
  try {
    const response = await API.put(`/product/synonyms/${productId}`, {
      ...payload,
    });
    return response.data;
  } catch (error: any) {
    throw error.response.data.errors;
  }
};
